import React, { Component } from 'react';
import { Row, Col, List, Spin, Alert, Card, Progress } from 'antd';
import { Link } from 'react-router-dom'
import { GroceryList } from '../../../../services/api';

export default class GroceryListList extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            lists: [],
            loading: false,
        };
        
        this.groceryListApi = new GroceryList(props);
    }

    componentDidMount() {
        this.fetchGroceryLists();
    }

    fetchGroceryLists = () => {
        this.setState({ loading: true });
        this.groceryListApi.all()
            .then(res => {
                this.setState({ lists: res.data.data, loading: false });
            })
            .catch(_ => {
                this.groceryListApi.retry({ cb: this.fetchGroceryLists });
            });
    }


    render() {
        const { loading, lists } = this.state;
        
        return (
            <Row>
                <Col span={24}>
                    <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Inköpslistor</h2>
                    {lists.length > 0 && (
                        <List
                            size="large"
                            grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 6, xxl: 3 }}
                            dataSource={lists}
                            renderItem={item => (
                                <List.Item>
                                    <Link to={{
                                        pathname: `/groceries/${item.id}`,
                                        state: { list: item }
                                    }}>
                                        <Card title={item.title} style={{ textAlign: 'center' }}>
                                            <Progress
                                                type="circle" 
                                                percent={(item.meta.completed / item.meta.total) * 100} 
                                                format={() => `${item.meta.completed}/${item.meta.total}`} 
                                                strokeColor="#EF7C39"
                                            />
                                        </Card>  
                                    </Link>
                                </List.Item>
                              )}
                        />
                    )}
                    
                    {loading && (
                        <div style={{textAlign:'center'}}>
                            <Spin size="large" />
                        </div>
                    )}
                
                    {!loading && lists.length === 0 && (
                        <div style={{textAlign: 'center'}}>
                            <Alert message="Inga inköpslistor finns tillgängliga. Du kan lägga till inköpslistor från recept eller menyer." type="warning" />
                        </div>
                    )}
                </Col>
            </Row>
        );
    }
}




// WEBPACK FOOTER //
// ./src/screens/dashboard/components/grocery-list/GroceryListList.js